import { render, staticRenderFns } from "./CoworkerIcons.vue?vue&type=template&id=99473a8a&scoped=true"
import script from "./CoworkerIcons.vue?vue&type=script&lang=js"
export * from "./CoworkerIcons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99473a8a",
  null
  
)

export default component.exports